export const actionsList = [
  {
    id: 1,
    name: "Навигация",
    slug: "navigation",
    icon: "fa-solid fa-compass", 
    actions: [
      {
        id: 11,
        name: "Перейти по ссылке (внутренняя)",
        slug: "go-to-ref",
        icon: "fa-solid fa-link", 
        description: "Переход по внутренней ссылке сайта",
        children: [
          {
            id: 111,
            name: "Якорная ссылка на блок",
            description: "Прокрутка страницы до выбранного блока по id или hash",
            functionName: "goToRef",
            placeholder: "Введите id или hash блока",
            showSelectElementButton: true
          },
          {
            id: 112,
            name: "Открыть в новом окне",
            disabled: true,
            description: "Открывает внутреннюю ссылку в новой вкладке браузера",
            functionName: "goTo",
            placeholder: "Введите внутренний URL",
            showSelectElementButton: false
          }
        ]
      },
      {
        id: 12,
        name: "Перейти на сторонний сайт",
        slug: "go-to-external",
        icon: "fa-solid fa-external-link-alt",
        description: "Открывает внешний сайт или ресурс по URL",
        children: [
          {
            id: 113,
            name: "Открыть внешний URL",
            description: "Открывает указанный внешний адрес в новой вкладке",
            functionName: "goTo",
            placeholder: "Введите полный внешний URL",
            showSelectElementButton: false
          }
        ]
      }
    ]
  },
  {
    id: 2,
    name: "Диаологовое окно",
    slug: "modal",
    icon: "fa-solid fa-window-maximize",
    actions: [
      {
        id: 21,
        name: "Открыть диаологовое окно",
        slug: "open-modal",
        icon: "fa-solid fa-window-restore",
        description: "Открывает диаологовое окно для отправки сообщений",
        children: [
          {
            id: 211,
            name: "Создание диалогового окна",
            description: "Создание диалогового окна",
            functionName: "openModal",
            placeholder: "",
            showSelectElementButton: false
          }
        ]
      }
    ]
  },
  {
    id: 3,
    name: "Копирование",
    slug: "copy",
    icon: "fa-solid fa-copy",
    actions: [
      {
        id: 31,
        name: "Скопировать email",
        slug: "copy-email",
        icon: "fa-solid fa-envelope",
        description: "Копирует email-адрес в буфер обмена",
        children: [
          {
            id: 311,
            name: "Копировать email",
            description: "Копирует выбранный email в буфер обмена",
            functionName: "copyText",
            placeholder: "Введите email",
            showSelectElementButton: false
          }
        ]
      },
      {
        id: 32,
        name: "Скопировать телефон",
        slug: "copy-phone",
        icon: "fa-solid fa-phone",
        description: "Копирует номер телефона в буфер обмена",
        children: [
          {
            id: 312,
            name: "Копировать телефон",
            description: "Копирует выбранный телефонный номер",
            functionName: "copyText",
            placeholder: "Введите номер телефона",
            showSelectElementButton: false
          }
        ]
      },
      {
        id: 33,
        name: "Скопировать ссылку",
        slug: "copy-link",
        icon: "fa-solid fa-link",
        description: "Копирует ссылку в буфер обмена",
        children: [
          {
            id: 313,
            name: "Копировать ссылку",
            description: "Копирует выбранный URL-адрес",
            functionName: "copyText",
            placeholder: "Введите ссылку",
            showSelectElementButton: false
          }
        ]
      },
      {
        id: 34,
        name: "Скопировать текст",
        slug: "copy-text",
        icon: "fa-solid fa-file-alt",
        description: "Копирует текст в буфер обмена",
        children: [
          {
            id: 314,
            name: "Копировать текст",
            description: "Копирует выбранный текст",
            functionName: "copyText",
            placeholder: "Введите текст",
            showSelectElementButton: false
          }
        ]
      }
    ]
  }
];
